import React from "react";
import ReactDOM from "react-dom/client";
import {
  BrowserRouter as Router,
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from "react-router-dom";

import { Provider } from "react-redux";
import { store } from "./redux/createStore";
import "./index.scss";
import App from "./App";
import ToastNotif from "components/ToastNotif";
import "react-toastify/dist/ReactToastify.min.css";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import { httpClientIntegration } from "@sentry/integrations";

// only add sentry to production
if (!!process.env.REACT_APP_SENTRY_DSN)
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    normalizeDepth: 10,
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.reactRouterV6Instrumentation(
          React.useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes
        ),
      }),
      new Sentry.Integrations.Breadcrumbs({
        includeState: true,
      }),
      new httpClientIntegration({
        failedRequestStatusCodes: [400],
        tracing: true,
        breadcrumbCategories: ["xhr", "fetch"],
      }),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: Number(process.env.REACT_APP_SENTRY_RATE) || 1.0,

    release: `web_app_v2@0.1.0`,
  });

const sentryOnError = (error) => {
  console.error(
    `An error has occurred in web app.\nError: ${error.toString()}\n`
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Sentry.ErrorBoundary onError={sentryOnError}>
    <React.StrictMode>
      <Provider store={store}>
        <Router basename="/">
          <App />
          <ToastNotif />
        </Router>
      </Provider>
    </React.StrictMode>
  </Sentry.ErrorBoundary>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
